import dateUtil from './dateUtil';

const isSame = (date1: string, date2: string, format: string): boolean =>
  dateUtil(date1, format).isSame(dateUtil(date2, format));

export default isSame;
